import { BASE_URL } from "./base";

export interface VersionInfo {
    tag: string;
    commit: string;
}

export function sendTestEmail(email: string) {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_URL}/dev/mail-test`, {
            method: "POST",
            body: JSON.stringify({ email }),
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.success) {
                    resolve(true);
                } else {
                    reject(json.message);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function getVersion(): Promise<VersionInfo> {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_URL}/dev/version`, {
            method: "GET",
            credentials: "include",
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.success) {
                    resolve(json.version);
                } else {
                    reject(json.message);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}
